/**
 * Секция редактирования данных клиента
 */

import React from 'react';
import { UpdateClientDataFormComponent } from '../forms/UpdateClientDataForm';
import type { ClientData } from '../../../types';

interface EditClientSectionProps {
  clientData: ClientData | null;
}

/**
 * Компонент секции "Редактирование данных клиента"
 */
export const EditClientSection: React.FC<EditClientSectionProps> = ({ clientData }) => {
  if (!clientData) {
    return (
      <div>
        <p style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center', marginTop: '50px' }}>
          Клиент не выбран. Пожалуйста, выберите клиента из панели справа.
        </p>
      </div>
    );
  }

  return (
    <div>
      <UpdateClientDataFormComponent clientData={clientData} />
    </div>
  );
};
